import getStorageData from "../Utils/getStorageData";
import { Images } from "./images";

const useRoutes = () => {
  const userType = getStorageData().userType;
  const userId = getStorageData()?.user?.id || "";

  //For master admin
  const allowedUserIds = [
    "67f5f80adf5b24d780bfd24c",
    "67beb885cd36b805b571cc2d",
    "66e55cbba53f0003767e4b29",
    "6957b435a2a46e17edea011d"
  ];
  const isUserAllowed = allowedUserIds.includes(userId || "");
  // for rnd debug user
  const allowedDebugUserIds = [
    "6961efd46fe340c3bed9137d",
  ];
  const isDebugUser = allowedDebugUserIds.includes(userId || "");
  let route = [];

  if (userType === 0) {
    if (isDebugUser) {
      route = [
        {
          img: Images.DebugDevice,
          activeImg: Images.ActiveDebugDevice,
          path: "/debug-device",
          name: "Debug Device",
          isShow: 1,
        },
        {
          img: Images.DebugDevice,
          activeImg: Images.ActiveDebugDevice,
          path: "/debug-device-details/:slave",
          name: "Debug Device",
          isShow: 0,
        },

        {
          img: Images.Settings,
          activeImg: Images.ActiveSetting,
          path: "/settings",
          name: "Settings",
          isShow: 1,
        },
      ];
    } else {
      route = [
        {
          img: Images.Search,
          activeImg: Images.ActiveSearch,
          path: "/search",
          name: "Search",
          isShow: 1,
        },
        {
          img: Images.Premises,
          activeImg: Images.ActivePremises,
          path: "/premises",
          name: "Premises",
          isShow: 0,
        },
        {
          img: Images.SubAdmin,
          activeImg: Images.ActiveSubAdmin,
          path: "/sub-admins",
          name: "Sub Admins",
          isShow: 0,
        },
        {
          img: Images.SubAdmin,
          activeImg: Images.ActiveSubAdmin,
          path: "/sub-admins/permissions",
          name: "Sub Admin Permissions",
          isShow: 0,
        },
        {
          img: Images.ServicePerson,
          activeImg: Images.ActiveServicePerson,
          path: "/service-person",
          name: "Service Person",
          isShow: 0,
        },
        // {
        //     img: Images.Premises,
        //     activeImg: Images.ActivePremises,
        //     path: "/area",
        //     name: "Area",
        //     isShow: 1
        // },
        ...(isUserAllowed
          ? [
              {
                img: Images.AdminDashboard,
                activeImg: Images.ActiveAdminDashboard,
                path: "/dashboard/request-dashboard",
                name: "Dashboard",
                isShow: 1,
              },
              {
                img: Images.AdminDashboard,
                activeImg: Images.ActiveAdminDashboard,
                path: "/dashboard/request-dashboard/device-dashboard",
                name: "User & Device Dashboard",
                isShow: 0,
              },
              {
                img: Images.AdminDashboard,
                activeImg: Images.ActiveAdminDashboard,
                path: "/dashboard/request-dashboard/streak-leaderboard",
                name: "Streak Leaderboard",
                isShow: 0,
              },
            ]
          : []),

        {
          img: Images.SubAdmin,
          activeImg: Images.ActiveSubAdmin,
          path: "/users/profile/:id",
          name: "Profile List",
          isShow: 0,
        },
        {
          img: Images.SubAdmin,
          activeImg: Images.ActiveSubAdmin,
          path: "/users/profile/device/:slaveId",
          name: "Profile List",
          isShow: 0,
        },
        ...(isUserAllowed
          ? [
              {
                img: Images.ScheduleLog,
                activeImg: Images.ActiveScheduleLog,
                path: "/schedules-logs",
                name: "Schedule Logs",
                isShow: 1,
              },
            ]
          : []),

        {
          img: Images.ScheduleLog,
          activeImg: Images.ActiveScheduleLog,
          path: "/feedback",
          name: "Feedback",
          isShow: 1,
        },
        {
          img: Images.staticOTP,
          activeImg: Images.ActiveStaticOTP,
          path: "/static-otp",
          name: "Static OTP",
          isShow: 1,
        },
        {
          img: Images.SendNotification,
          activeImg: Images.ActiveSendNotification,
          path: "/send-notification",
          name: "Notification",
          isShow: 1,
        },

        ...(isUserAllowed
          ? [
              {
                img: Images.SendNotification,
                activeImg: Images.ActiveSendNotification,
                path: "/templates",
                name: "Templates",
                isShow: 1,
              },
              {
                img: Images.AdminDashboard,
                activeImg: Images.ActiveAdminDashboard,
                path: "/air-analytics",
                name: "Air Analytics",
                isShow: 1,
              },
              {
                img: Images.Users,
                activeImg: Images.ActiveUsers,
                path: "/air-segment",
                name: "Air Segment",
                isShow: 1,
              },
              {
                img: Images.Dashboard,
                activeImg: Images.ActiveDashboard,
                path: "/air-flow",
                name: "Air Flow",
                isShow: 1,
              },
            ]
          : []),

        {
          img: Images.DebugDevice,
          activeImg: Images.ActiveDebugDevice,
          path: "/debug-device",
          name: "Debug Device",
          isShow: 1,
        },
        {
          img: Images.DebugDevice,
          activeImg: Images.ActiveDebugDevice,
          path: "/debug-device-details/:slave",
          name: "Debug Device",
          isShow: 0,
        },

        ...(isUserAllowed
          ? [
              {
                img: Images.Firmware,
                activeImg: Images.ActiveFirmware,
                path: "/firmware",
                name: "Firmware",
                isShow: 1,
              },
            ]
          : []),
        {
          img: Images.Firmware,
          activeImg: Images.ActiveFirmware,
          path: "/test-firmware",
          name: "Test Firmware",
          isShow: 1,
        },
        ...(isUserAllowed
          ? [
              {
                img: Images.Logs,
                activeImg: Images.ActiveLogs,
                path: "/logs",
                name: "Logs",
                isShow: 1,
              },
              {
                img: Images.Backup,
                activeImg: Images.ActiveBackup,
                path: "/backup",
                name: "Backup",
                isShow: 1,
              },
            ]
          : []),
        {
          img: Images.Premises,
          activeImg: Images.ActivePremises,
          path: "/master",
          name: "Master",
          isShow: 0,
        },
        {
          img: Images.Settings,
          activeImg: Images.ActiveSetting,
          path: "/settings",
          name: "Settings",
          isShow: 1,
        },
        // {
        //     img: Images.DebugDevice,
        //     activeImg: Images.ActiveDebugDevice,
        //     path: "/testing",
        //     name: "Testing",
        //     isShow: 1
        // },
        // {
        //     img: Images.DebugDevice,
        //     activeImg: Images.ActiveDebugDevice,
        //     path: "/testing/testing-of-details/:id",
        //     name: "Testing",
        //     isShow: 0
        // },
        // {
        //     img: Images.DebugDevice,
        //     activeImg: Images.ActiveDebugDevice,
        //     path: "/testing/testing-details-of-details/:id",
        //     name: "Testing",
        //     isShow: 0
        // },
      ];
    }
  }
  return route;
};

export default useRoutes;
